import React, { useEffect } from 'react';
import { useAppState } from './State';
import PortalContainer from './Components/FitAssistantButton/PortalContainer';
import ModalContent from './Components/Modal/ModalContent';
import ModalBackdrop from './Components/Modal/ModalBackdrop';
import StepRouter from './StepRouter';

const RearMountedChildBikeSeats = () => {
  const { showFitAssistant, setShowFitAssistant } = useAppState();

  const html: HTMLElement | null = document.querySelector('html');
  const body: HTMLElement | null = document.querySelector('body');
  const thuleWidget: HTMLElement | null = document.querySelector('div[data-thule-widget]');

  const params = new URLSearchParams(window.location.search);
  useEffect(() => {
    if (params.has('openFa')) setShowFitAssistant(true);
  }, []);

  useEffect(() => {
    if (showFitAssistant) {
      html?.classList.add('overflow-hidden');
      body?.classList.add('overflow-hidden');
      if (thuleWidget) thuleWidget.style.display = 'none';
    } else {
      html?.classList.remove('overflow-hidden');
      body?.classList.remove('overflow-hidden');
      if (thuleWidget) thuleWidget.style.display = 'inline';
    }
  }, [showFitAssistant]);

  return (
    <>
      <PortalContainer />
      <ModalContent>
        <StepRouter />
      </ModalContent>
      <ModalBackdrop />
    </>
  );
};

export default RearMountedChildBikeSeats;
